import React from "react";
import { useNavigate } from "react-router-dom";

const JobCard = ({ id, date, icon, category, title, requirements, salary ,gender }) => {
  const navigate = useNavigate();

  const handleDetailsClick = (e) => {
    e.preventDefault(); // prevent page reload
    // 👇 Navigate to ApplyJob page with the job ID
    navigate(`/ApplyJob/${id}`);
  };

  return (
    <div className="job-detail">
      <div className="job-top">
        <div className="top-detail">
          <div className="job-date">
            <p>{date}</p>
          </div>
          <div className="job-icon">
            <img src={icon} alt="job icon" width="24px" height="24px" />
          </div>
        </div>

        <div className="job-tital">
          <p>{category}</p>
          <p className="tital">{title}</p>
        </div>

        <div className="job-Req">
          {requirements.map((req, index) => (
            <div className="req" key={index}>
              <p>{req}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="job-buttom">
        <div className="buttom-text">
          <div className="context">
          <h1>Salary</h1>
          <p>{salary} </p>
          </div>
          <a href="#" className="rounded-btn" onClick={handleDetailsClick}>
            Details
          </a>
        </div>
        <br />
            <div className="context">
              <h1>Gender Validity</h1>
              <p>{gender}</p>
            </div>

      </div>
    </div>
  );
};

export default JobCard;
